import { FaMapMarkerAlt } from "react-icons/fa";

export default function VenueLocation({ children }) {
	return (
		<div className="flex items-center gap-1 min-h-[24px] overflow-hidden">
			<FaMapMarkerAlt className="text-[#FE4747] flex-shrink-0 text-sm" />
			<p className="text-secondary font-outfit font-normal text-[15px] leading-[156%] tracking-[0.01em] overflow-hidden text-ellipsis whitespace-nowrap">
				{children}
			</p>
		</div>
	);
}
